import { useState, useEffect } from "react";

const useLandingPageData = () => {
  const [landingPageData, setLandingPageData] = useState(null);

  const fetchLandingPageData = async (retries = 6) => {
    try {
      const authToken =
        sessionStorage.getItem("token") || process.env.REACT_APP_TEMP_TOKEN;
        // alert(authToken+"");
      const response = await fetch(
        process.env.REACT_APP_RANK_PLUS_LANDING_PAGE_DATA,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status >= 500 && response.status < 600 && retries > 0) {
          console.warn(`Retrying... attempts left: ${retries}`);
          setTimeout(() => fetchLandingPageData(retries - 1), 10000);
          return;
        } else {
          throw new Error(`HTTP error: ${response.status}`);
        }
      }

      const json = await response.json();
      setLandingPageData(json);
    } catch (err) {
      console.error("Error in useLandingPageData: ", err);
    }
  };

  useEffect(() => {
    fetchLandingPageData();
  }, []);

  return landingPageData;
};

export default useLandingPageData;
